import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from "../ui/Loader";
import SelectDropdown from "../components-react/SelectDropdown";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { odm_update_gym_id } from "../../data/ApiEndpoints";
import { commonPostPutApi1 } from "../../redux/reducers/commonApiSlice";
import { PersonIcon, CallIcon, EmailIcon } from "../../images/icons/icons";

const MapGymForm = ({ userInfoData, closeModal, callFunction, rowData }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.common);
  const gymData = useSelector(selectGymData);

  const iniFormValues = {
    selectedGym: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    if (!formValues.selectedGym) {
      errors.selectedGym = "Required!";
    }

    return errors;
  };

  const handleUpdate = async (requestBody) => {
    const method = "POST";
    const endpoint = odm_update_gym_id;
    const payload = requestBody;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi1({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Gym mapped successfully!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      toast.error("Something Went Wrong!");
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        uid: rowData?.uid || "",
        gym_id: formValues.selectedGym?.value || "",
        is_pt: 0,
      };

      const handleConfirm = async () => {
        handleUpdate(userData);
      };

      showConfirmAlert(handleConfirm, `Are you sure you want to map this gym?`);
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="form-container add-new-job">
      <form className="formContainer">
        <div className="tb-member-info-section">
          <h4 className="tb-member-info-title">Member Details</h4>
          <div className="tb-member-info-grid">
            <div className="tb-member-info-item">
              <span className="tb-member-info-icon">
                <PersonIcon />
              </span>
              <div className="tb-member-info-content">
                <span className="tb-member-info-label">Name</span>
                <span className="tb-member-info-value">
                  {rowData?.user_name || "NA"}
                </span>
              </div>
            </div>

            <div className="tb-member-info-item">
              <span className="tb-member-info-icon">
                <CallIcon />
              </span>
              <div className="tb-member-info-content">
                <span className="tb-member-info-label">Mobile</span>
                <span className="tb-member-info-value">
                  {rowData?.user_mobile || "NA"}
                </span>
              </div>
            </div>

            <div className="tb-member-info-item">
              <span className="tb-member-info-icon">
                <EmailIcon />
              </span>
              <div className="tb-member-info-content">
                <span className="tb-member-info-label">Email</span>
                <span className="tb-member-info-value tb-member-info-email">
                  {rowData?.user_email || "NA"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="selectedGym" className="formInputLabel">
              Select Gym *
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedGym ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={gymData}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedGym", selectedValue)
                }
                name="Gym"
              />
            </div>
            {formErrors.selectedGym && (
              <span className="errorText">{formErrors.selectedGym}</span>
            )}
          </div>
        </div>

        <div
          className="formButtons mt30"
          style={{ justifyContent: "flex-end" }}
        >
          <Button className="saveBtn" variant="danger" onClick={onSubmitForm}>
            {loading ? <Loader /> : "Map Gym"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default MapGymForm;
